export const themeSummaries = [
  {
    "id": "duo",
    "desc": "duo célèbres",
    "visible": true,
    "alphabet": "fr",
    "langue": "fr",
    "number": 36
  },
  {
    "id": "departements",
    "desc": "retrouver le nom du département correspondant au numéro",
    "visible": true,
    "alphabet": "fr",
    "langue": "fr",
    "number": 101
  },
  {
    "id": "mendeleiev",
    "desc": "retrouver le nom des elements a partir de leur symbole chimiques du tableau de Mendeleiev (inclut seulement les 6 premières lignes dudit tableau).",
    "visible": true,
    "alphabet": "fr",
    "langue": "fr",
    "number": 72
  },
  {
    "id": "monnaies",
    "desc": "retrouver le nom des monnaies utilisées dans ces organisations.",
    "visible": true,
    "alphabet": "fr",
    "langue": "fr",
    "number": 39
  },
  {
    "id": "pseudonymes",
    "desc": "Saurez vous retrouver le prénom original de ces personnalités publiques ?",
    "visible": true,
    "alphabet": "fr",
    "langue": "fr",
    "number": 68
  },
  {
    "id": "leçonSloveneAvoir",
    "desc": "Trouver les correspondances en slovènes",
    "visible": false,
    "alphabet": "sl",
    "langue": "fr",
    "number": 34
  },
  {
    "id": "leçonSloveneBases",
    "desc": "Trouver les correspondances en slovènes",
    "visible": false,
    "alphabet": "sl",
    "langue": "fr",
    "number": 35
  },
  {
    "id": "leçonSloveneExpressions",
    "desc": "Trouver les correspondances en slovènes",
    "visible": false,
    "alphabet": "sl",
    "langue": "fr",
    "number": 25
  },
  {
    "id": "leçonSloveneFamille",
    "desc": "Trouver les correspondances en slovènes",
    "visible": false,
    "alphabet": "sl",
    "langue": "fr",
    "number": 33
  },
  {
    "id": "leçonSloveneIm",
    "desc": "Trouver les correspondances en slovènes",
    "visible": false,
    "alphabet": "sl",
    "langue": "fr",
    "number": 26
  },
  {
    "id": "leçonSloveneDifficile",
    "desc": "Mots que je mémorise le plus mal",
    "visible": false,
    "alphabet": "sl",
    "langue": "fr",
    "number": 16
  },
  {
    "id": "leçonSloveneSentenceJournee",
    "desc": "Phrases slovène générique a prononcer en journée",
    "visible": false,
    "alphabet": "sl",
    "langue": "fr",
    "number": 25
  },
  {
    "id": "leçonSloveneDay",
    "desc": "Trouver les correspondances en slovènes",
    "visible": false,
    "alphabet": "sl",
    "langue": "fr",
    "number": 35
  },
  {
    "id": "leçonSloveneEtre",
    "desc": "Trouver les correspondances en slovènes",
    "visible": false,
    "alphabet": "sl",
    "langue": "fr",
    "number": 29
  },
  {
    "id": "leçonSloveneFeed",
    "desc": "Trouver les correspondances en slovènes",
    "visible": false,
    "alphabet": "sl",
    "langue": "fr",
    "number": 35
  },
  {
    "id": "leçonSloveneSentenceFeed",
    "desc": "Trouver les correspondances en slovènes",
    "visible": false,
    "alphabet": "sl",
    "langue": "fr",
    "number": 25
  },
  {
    "id": "sloveneHave",
    "desc": "Find the Slovenian equivalents for to have",
    "visible": true,
    "alphabet": "sl",
    "langue": "en",
    "number": 34
  },
  {
    "id": "sloveneBasics",
    "desc": "Find the Slovenian equivalents",
    "visible": true,
    "alphabet": "sl",
    "langue": "en",
    "number": 35
  },
  {
    "id": "sloveneExpressions",
    "desc": "Find the Slovenian equivalents for common expressions",
    "visible": true,
    "alphabet": "sl",
    "langue": "en",
    "number": 25
  },
  {
    "id": "sloveneFamily",
    "desc": "Find the Slovenian equivalents for family words and profile fields",
    "visible": true,
    "alphabet": "sl",
    "langue": "en",
    "number": 33
  },
  {
    "id": "sloveneAboutMe",
    "desc": "Find the Slovenian equivalents for introducing yourself",
    "visible": true,
    "alphabet": "sl",
    "langue": "en",
    "number": 26
  },
  {
    "id": "sloveneDifficult",
    "desc": "Slovenian words I memorize the least well",
    "visible": true,
    "alphabet": "sl",
    "langue": "en",
    "number": 16
  },
  {
    "id": "sloveneSentenceDay",
    "desc": "Generic Slovenian daily sentences",
    "visible": true,
    "alphabet": "sl",
    "langue": "en",
    "number": 25
  },
  {
    "id": "sloveneDay",
    "desc": "Find the Slovenian equivalents for daily routine words",
    "visible": true,
    "alphabet": "sl",
    "langue": "en",
    "number": 35
  },
  {
    "id": "sloveneBe",
    "desc": "Find the Slovenian equivalents for to be",
    "visible": true,
    "alphabet": "sl",
    "langue": "en",
    "number": 29
  },
  {
    "id": "sloveneFood",
    "desc": "Find the Slovenian equivalents for food and shopping words",
    "visible": true,
    "alphabet": "sl",
    "langue": "en",
    "number": 35
  },
  {
    "id": "sloveneSentenceFood",
    "desc": "Generic Slovenian food and shopping sentences",
    "visible": true,
    "alphabet": "sl",
    "langue": "en",
    "number": 25
  },
  {
    "id": "europeanCapitals",
    "desc": "Find all the capitals for European continent",
    "visible": true,
    "alphabet": "en",
    "langue": "en",
    "number": 27
  },
  {
    "id": "africanCapitals",
    "desc": "Find all the capitals for African continent",
    "visible": true,
    "alphabet": "en",
    "langue": "en",
    "number": 53
  },
  {
    "id": "animauxScientifiques",
    "desc": "Trouver la dénomination scientifique en latin de ces animaux.",
    "visible": true,
    "alphabet": "fr",
    "langue": "fr",
    "number": 20
  },
  {
    "id": "planets",
    "desc": "Find all the planets name by their index, starting from the closest to the sun to the farest.",
    "visible": true,
    "alphabet": "en",
    "langue": "en",
    "number": 8
  },
  {
    "id": "frenchlesson",
    "desc": "guess some basics french words",
    "visible": true,
    "alphabet": "fr",
    "langue": "en",
    "number": 35
  },
  {
    "id": "bolchevisme",
    "desc": "Retrouvez le nom original des villes renommées par les bolchéviques.",
    "visible": true,
    "alphabet": "fr",
    "langue": "fr",
    "number": 21
  },
  {
    "id": "test",
    "desc": "test",
    "visible": false,
    "alphabet": "fr",
    "langue": "en",
    "number": 9
  },
  {
    "id": "capboulangerieAccronymes",
    "desc": "Décoder les accronymes",
    "visible": false,
    "alphabet": "fr",
    "langue": "fr",
    "number": 37
  },
  {
    "id": "capboulangerieOeuf",
    "desc": "La constitution de l'oeuf",
    "visible": false,
    "alphabet": "fr",
    "langue": "fr",
    "number": 10
  },
  {
    "id": "capboulangerieElectrique",
    "desc": "Unités d'électricité",
    "visible": false,
    "alphabet": "fr",
    "langue": "fr",
    "number": 8
  },
  {
    "id": "capboulangeriePetrissage",
    "desc": "Pétrissage, étapes et Pétrin",
    "visible": false,
    "alphabet": "fr",
    "langue": "fr",
    "number": 16
  }
]
